<template>
	<div class="am-timeline"
		:class="{ 'is-idle': !init || !loaded }"
	>
		<!-- <div class="am-timeline__background" :data-src="background">
		</div> -->

		<div class="am-timeline__container">
			<div class="am-timeline__wrapper">
				<header class="am-timeline__header">
					<am-text class="am-timeline__title am-timeline__title--third" type="title">
						<span>
							{{ title }}
						</span>
					</am-text>
				</header>

				<am-text class="am-timeline__text" type="body">
					{{ text }}
				</am-text>
				<router-link class="open--modal text-white text-decoration-none" to="/acompanhamento">Saiba mais</router-link>

			</div>

			<div class="am-timeline__image" :data-src="image">
			</div>
		</div>
	</div>
</template>
A
<script>
import AMText from '@/components/atoms/AMText'
import { TweenMax, Power2 } from 'gsap/TweenMax'

export default {
	components: {
		'am-text': AMText,
	},

	props: {
		init: {
			type: Boolean,
			default: true
		},
		title: {
			type: String,
			default: 'Acompanhe o andamento da obra'
		},
		text: {
			type: String,
			default: 'Adipisicing quo delectus deleniti aut quis, quasi totam? Vero adipisci nostrum itaque ducimus culpa?'
		},
		background: {
			type: String,
			default: 'https://placeimg.com/640/480/nature/grayscale'
		},
		image: {
			type: String,
			default: 'https://placeimg.com/640/480/nature'
		}
	},
	
	data: () => ({
		loaded: false
	}),

	watch: {
		init(value) {
			if (value)
				this.onLoad()
		}
	},

	mounted() {
		if (this.init)
			this.onLoad()
	},

	methods: {
		start() {
			// Background
			TweenMax.staggerFrom(this.$el.querySelectorAll('.am-timeline__background'), 1.5, {
				y: '-200px',
				opacity: 0,
				ease: Power2.easeOutl
			})

			// Gallery
			TweenMax.staggerFrom(this.$el.querySelectorAll('.am-timeline__image'), 2, {
				x: '30%',
				opacity: 0,
				ease: Power2.easeOut
			})

			// Titles
			TweenMax.staggerFrom(this.$el.querySelectorAll('.am-timeline__title span'), 1.5, {
				delay: .2,
				y: '200px',
				ease: Power2.easeOut
			}, .2)
		},

		onLoad() {
			let images = this.$el.querySelectorAll('.am-timeline__image, .am-timeline__background')

			images.forEach((image, index) => {
				let img = new Image()

				img.src = image.dataset.src
				img.onload = () => {
					image.style.backgroundImage = `url(${img.src})`

					if (index + 1 == images.length) {
						this.loaded = true
						this.start()
					}
				}
			})
		}
	}
}
</script>

<style lang="scss">
	.open--modal{
		display: inline-block;
	    background: #99887F;
	    color: #fff;
	    font-family: Khand;
	    max-width: max-content;
	    padding: 10px 50px;
	    border-radius: 50px;
	    margin-top: 15px;
	    margin-bottom: 20px;
	    cursor: pointer;
	    font-size: 16px;
	    transition: 0.4s cubic-bezier(0.455, 0.03, 0.515, 0.955);
	    &:hover{
	    	opacity: 0.7
	    }
	}
.am-timeline{
	background: white;
	position: relative;
	z-index: 10;
	transition: .3s $easeInOutQuad;
	&__container{
		display: flex;
		flex-flow: column;
		height: 100%;
		@include outer-container;
	}
	&__wrapper{
		flex: 1;
		@include grid-column(6);
	}
	&__background{
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100px;
		opacity: 1;
		z-index: -1;
		background-size: cover;
		background-position: center;
	}
	&__header{
		margin-top: 54px;
		margin-bottom: 32px;
		padding-bottom: 100px;
		position: relative;
		max-width: 410px;
		&:after{
			content: "";
			position: absolute;
			width: 100%;
			height: 1px;
			bottom: -1px;
			background: rgba($c-gray, .6);
			transition: 1s $easeInOutQuad .75s;
		}
	}

	@media only screen and (max-width: 1400px) {
		&__header{
			padding-bottom: 34px;
		}
	}
	&__title{
		line-height: 56px;
		overflow: hidden;
		span{
			display: block;
		}
		&--first{
			color: white;
		}
		&--second{
			color: #E3E3E3;
		}
		&--third{
		}
	}
	&__text{
		opacity: .8;
		margin-bottom: 40px;
		transition: 1s $easeOutQuad 1.5s;
	}
	&__image{
		flex: 1;
		background-size: cover;
		background-position: center;
	}
	@include grid-media($tablet-grid) {
		&__header{
			margin-top: 34px;
			margin-bottom: 22px;
		}
		&__text{
			margin-bottom: 0px;
		}
		&__header span{
			font-size: 44px;
			line-height: 44px;
		}
	}
	@include grid-media($smartphone-grid) {
		&__header{
			margin-top: 34px;
			margin-bottom: 22px;
		}
		&__text{
			margin-bottom: 0px;
		}
		&__header span{
			font-size: 44px;
			line-height: 44px;
		}
	}

	&.is-idle{
		opacity: 0;
		.am-timeline{
			&__header{
				&:after{
					width: 0%;
					opacity: 0;
					transition: .5s $easeInOutQuad;
				}
			}
			&__text{
				transform: translateY(20px);
				opacity: 0;
				transition: .5s $easeInOutQuad;
			}
		}
	}

	@include grid-media($tablet-grid) {
		&__wrapper{
			@include grid-column(4);
		}
	}
	&__image{
		object-fit: cover;
	}
	@include grid-media($desktop-grid) {
		display: block;
		&__image{
			position: absolute;
			top: 0;
			right: 0;
			bottom: 0;
			left: 50%;
			&:after{
				content: "";
				display: block;
				padding-top: 60%;
			}
		}
		&__background{
			height: 200px;
		}
		&__header{
			margin-top: 144px;
			&:after{
				width: 280px;
			}

		}
		&__title{
			line-height: 64px;
		}
		&__wrapper{
			@include grid-column(5);
		}
		@media only screen and (max-width: 1400px) {
			&__wrapper{
				@include grid-column(6);
			}
		}

	}
}
</style>
